// Jquery
require('webpack-jquery-ui/autocomplete')
$(document).ready( function() {

    // Search suggestions
    const searchInput = $('#search-input');
    const suggestionContainer = $('#suggestion-container');
    const searchForm = $('#search-form');


    searchInput.on('input', function() {
        const query = searchInput.val().trim();
        if (query.length >= 2) {
            fetch($('form#search').attr('action') + '?term=' + query, {
                method: "GET",
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    "Accept": "application/json",
                },
            })
                .then(response => response.json())
                .then(data => {
                    const suggestionsHtml = "<ul>" + data.map(item => {
                        return `<li><a href="${item.url}">
                                <span>${item.label}
                                    ${ item.voters_count ? `<small> ${item.voters_count}  ${item.voters}</small>` : `` }
                                </span>
                                <i data-star="${item.note}"></i>
                            </a></li>`;
                    }).join('') + "</ul>";
                    suggestionContainer.find('ul').remove(); // remove any existing ul element
                    suggestionContainer.find('.ajoutermarque').before(suggestionsHtml);
                    suggestionContainer.css('display', 'block');
                })
        } else {
          suggestionContainer.css('display', 'none');
        }
    });

    suggestionContainer.on('click', 'li', function() {
      const suggestionText = $(this).find('span').html().replace(/<small>(.*?)<\/small>/g, '');
      searchInput.val(suggestionText.trim());
      suggestionContainer.css('display', 'none');
    });

    $(document).on('click', function(event) {
      if (!searchInput.is(event.target) && !suggestionContainer.is(event.target) && suggestionContainer.has(event.target).length === 0) {
        suggestionContainer.css('display', 'none');
      }
    });

});
